import { create } from "zustand";

import { IntegrationEnvironment } from "../ServerEndpoints";

import { actions } from "./actions";
import { Store } from "./types";

export const store = create<Store>((set, get) => ({
  isInitialized: false,
  integrationId: undefined,
  environment: IntegrationEnvironment.Prod,
  ...actions(set, get),
}));
export const useStore = store;
